/**
 * 逻辑与平台的  预约提货组件 BatchPickUpPoDrawer
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 *
 **/
import React from "react";
import {Button, Drawer, Spin,} from 'antd';
import Lang from '@components/Lang/Lang';
import AuthBtn from "@components/HoverIcon/AuthBtn";
import {isEmpty} from "@utils/utils";
import StepSecondShow from "./stepSecond/stepSecondShow";
import PickUpPoDrawerAction from "./pickUpPoDrawer.action";
import './index.less'
export default class showPickUpPoDrawer extends React.Component{
    static defaultProps = {
        poIds:"",
        deliveryOrderId:""
    };
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            loading:false,
            showStep: 2,
            modelTwo:{},
            address:{},// 收货地址
        }
    }
    /**
     * 抽屜
     * */
    showDrawer = (flag=true) => {
        if(flag){
            this.goStepTwo(this.props.poIds)
        }else {
            this.setState({
                visible: flag,
            });
        }
    };
    goStepTwo(poIds,callBack){
       // 有提货ID的为编辑 状态
       //  const sUrl= "/mg/abd/whs/deliveryOrder/delivery-order-initi";
         const data = {
             // poIds	: poIds,
             deliveryOrderId:this.props.deliveryOrderId
         }
        this.loading(true);
        //   this.postHttpAction(sUrl, data,resData=>{
        PickUpPoDrawerAction.getDeliveryIniti(data).then((res)=>{
            const resData = res.data||{}
            // 响应结果
            this.loading(false)
            let { success, valid, model={}} = resData;
            let address = {};
            if(model.consigneeList&&model.consigneeList.length>0){
                address = model.consigneeList.find(item=>item.isSelect==1)
            }
            console.log("address",address)
            if (success && valid) {
                this.setState({
                    modelTwo: model,
                    address:address||{},
                    // selectIds:poIds||model.poIds,//编辑状态下 会返回 poIds数据
                    visible: true,
                });
                if(typeof callBack == 'function'){
                    callBack(model)
                }
            }
        })
    }
    // 标题2
    titleTwo(){
        return (<div className={"flex-item-between"}>
            {Lang({id:"YuYueTiHuo", default:"预约提货"})}
            <span>
                <Button onClick={()=>this.showDrawer(false)}>
                    {Lang({id:"GuanBi", default:"关闭"})}
                </Button>
           </span>
        </div>)
    }
    // 初始化
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    // 步骤组件
    onRefTwo = (ref) =>this.onRefChildTwo = ref;
    componentWillMount(){
    }
    componentDidMount() {
        if(this.props.onRef)this.props.onRef(this);
    };
    // componentWillUnmount() {
    //     if(this.timer)clearTimeout(this.timer);
    // }
    render() {
        const { selectIds,visible, loading, modelTwo, address} = this.state;
        const {poIds,pickupType } = this.props;
        return (<>
            <AuthBtn icon={"ri-article-line"} tips = {Lang({id:"YuYueXinXi",default:"预约信息"})}
                     onClick={()=>this.showDrawer(true)}/>
             <Drawer title={this.titleTwo()}
                    placement="right"
                    closable={false}
                     maskClosable={false}
                    width={700}
                    onClose={()=>this.showDrawer(false)}
                    open={visible}>
                <Spin spinning={loading}>
                    <StepSecondShow modelTwo={modelTwo}
                                    poIds={poIds}
                                    selectIds={selectIds}
                                    pickupType={pickupType}
                                    address={address||{}}
                                    reLoadTwo={(callBack)=>this.goStepTwo(selectIds,callBack)}
                                    onRef={this.onRefTwo} />
                </Spin>
            </Drawer>
        </>);
    }
}

